import React, { useEffect, useState } from 'react';

import { array, string, bool } from 'prop-types';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

import { isEmpty } from 'lodash';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import ListItemText from '@material-ui/core/ListItemText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import BobConfirmButton from './BobConfirmButton';
import BobCancelButton from './BobCancelButton';

import * as classes from './BobFilterComponent.module.css';

const BobFilterComponent = ({
    activeFilters,
    label,
    data,
    filterType,
    setFilters,
    showStatusFilter,
    ...props
}) => {

    const statusList = ['Fault', 'Ok'];

    const [filterOpen, setFilterOpen] = useState(false);
    const [hasFilter, setHasFilter] = useState(false);
    const [selectedType, setSelectedType] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedPriority, setSelectedPriority] = useState({});

    useEffect(() => {
        setSelectedType(activeFilters.type);
        setSelectedPriority(activeFilters.priority);
        setSelectedStatus(activeFilters.status);
    }, [activeFilters]);

    useEffect(() => {
        if (showStatusFilter) {
            if (isEmpty(selectedType) && isEmpty(selectedStatus) && !selectedPriority.high && !selectedPriority.medium && !selectedPriority.low) {
                setHasFilter(false);
            } else {
                setHasFilter(true);
            }
        } else {
            if (isEmpty(selectedType) && !selectedPriority.high && !selectedPriority.medium && !selectedPriority.low) {
                setHasFilter(false);
            } else {
                setHasFilter(true);
            }
        }
    }, [selectedType, selectedPriority, selectedStatus]);

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 225,
                width:     250,
            },
        },
    };

    const handleToggle = () => {
        setFilterOpen(!filterOpen);
    };

    const handleChange = (event) => {
        setSelectedType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
    };
    
    const handlePriorityChange = (event) => {
        setSelectedPriority({ ...selectedPriority, [event.target.name]: event.target.checked });
    };

    const resetFilter = () => {
        setFilters({
            type:     [],
            priority: {
                high:   false,
                medium: false,
                low:    false
            },
            status: []
        });
    };

    const handleClickAway = () => {
        setFilterOpen(false);
    };

    const handleFilterApply = () => {
        setFilters({
            type:     selectedType,
            priority: selectedPriority,
            status:   selectedStatus
        });

        setFilterOpen(false);
    };

    return (
        <ClickAwayListener
            onClickAway={handleClickAway}
        >
            <span>
                <Button
                    className={classes.FilterButton}
                    onClick={handleToggle}
                >
                    <i className="fas fa-filter" aria-hidden="true" />
                </Button>
                {
                    filterOpen ? 
                        <Paper className={classes.BobFilterComponentMenu}>
                            <React.Fragment>
                                <FormControl className={classes.TypeSelect}>
                                    <InputLabel className={classes.Label} id="demo-mutiple-checkbox-label">{label}</InputLabel>
                                    <Select
                                        labelId="demo-mutiple-checkbox-label"
                                        id="demo-mutiple-checkbox"
                                        className={classes.MultiSelect}
                                        multiple
                                        input={<Input />}
                                        value={selectedType}
                                        onChange={handleChange}
                                        renderValue={(selected) => selected.map(type => type.name).join(', ')}
                                        MenuProps={MenuProps}
                                        variant="filled"
                                    >
                                        {data.map((item, index) => (
                                            <MenuItem key={index} value={item}>
                                                <Checkbox
                                                    classes={{
                                                        root: classes.Checkbox
                                                    }}
                                                    checked={selectedType.map(type => type.name).indexOf(item.name) > -1}
                                                />
                                                <ListItemText className={classes.Font} primary={item.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {
                                    showStatusFilter ?
                                        <FormControl className={classes.TypeSelect}>
                                            <InputLabel className={classes.Label} id="demo-mutiple-checkbox-label">Status</InputLabel>
                                            <Select
                                                labelId="demo-mutiple-checkbox-label"
                                                id="demo-mutiple-checkbox"
                                                className={classes.MultiSelect}
                                                multiple
                                                input={<Input />}
                                                value={selectedStatus}
                                                onChange={handleStatusChange}
                                                renderValue={(selected) => selected.map(type => type).join(', ')}
                                                MenuProps={MenuProps}
                                                variant="filled"
                                            >
                                                {statusList.map((item, index) => (
                                                    <MenuItem key={index} value={item}>
                                                        <Checkbox
                                                            classes={{
                                                                root: classes.Checkbox
                                                            }}
                                                            checked={selectedStatus.map(type => type).indexOf(item) > -1}
                                                        />
                                                        <ListItemText className={classes.Font} primary={item} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        : null    
                                }
                                <FormControl className={classes.PriorityContainer}>
                                    <FormLabel className={classes.Label}>Priority</FormLabel>
                                    <FormGroup className={classes.CheckboxContainer}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    classes={{
                                                        root: classes.Checkbox
                                                    }}
                                                    checked={selectedPriority.high}
                                                    onChange={handlePriorityChange}
                                                    name="high"
                                                />
                                            }
                                            label={
                                                <div className={classes.Font}>
                                                    <img className={classes.IconImage} src="/assets/images/high.svg" alt="" />
                                                    High
                                                </div>
                                            }
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    classes={{
                                                        root: classes.Checkbox
                                                    }}
                                                    checked={selectedPriority.medium}
                                                    onChange={handlePriorityChange}
                                                    name="medium"
                                                />
                                            }
                                            label={
                                                <div className={classes.Font}>
                                                    <img className={classes.IconImage} src="/assets/images/medium.svg" alt="" />
                                                    Medium
                                                </div>
                                            }
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    classes={{
                                                        root: classes.Checkbox
                                                    }}
                                                    checked={selectedPriority.low}
                                                    onChange={handlePriorityChange}
                                                    name="low"
                                                />
                                            }
                                            label={
                                                <div className={classes.Font}>
                                                    <img className={classes.IconImage} src="/assets/images/low.svg" alt="" />
                                                    Low
                                                </div>
                                            }
                                        />
                                    </FormGroup>
                                </FormControl>
                            </React.Fragment>
                            <div>
                                {
                                    hasFilter ? 
                                        <i onClick={resetFilter} className={`fas fa-undo fa-lg ${classes.FilterIcon}`} aria-hidden="true" />
                                        :
                                        null
                                }
                                <BobCancelButton
                                    className={classes.Buttons}
                                    label={'Cancel'}
                                    cancel={handleToggle}
                                />
                                <BobConfirmButton
                                    className={classes.Buttons}
                                    label={'Ok'}
                                    onClick={handleFilterApply}
                                />
                            </div>
                        </Paper>
                        :
                        null
                }
            </span>
        </ClickAwayListener>
    );
};

BobFilterComponent.defaultProps = {
    label:            '',
    data:             [],
    showStatusFilter: false
};

BobFilterComponent.propTypes = {
    label:            string,
    data:             array,
    showStatusFilter: bool
};

export default BobFilterComponent;
